export type FontWeightTypes = typeof fontWeight;
export type FontSizeTypes = typeof fontSize;

export const fontWeight = {
	weightThin: 100,
	weightLight: 300,
	weightRegular: 400,
	weightMedium: 500,
	weightSemi: 600,
	weightBold: 700,
	weightBlack: 900,
};

export const fontSize = {
	size2xs: '1.2rem',
	sizeXs: '1.3rem',
	sizeSm: '1.4rem',
	sizeMd: '1.6rem',
	sizeLg: '1.8rem',
	sizeXl: '2rem',
	size2xl: '2.4rem',
	size3xl: '2.8rem',
	size4xl: '3.2rem',
	size5xl: '3.6rem',
	size6xl: '4rem',
	size7xl: '4.8rem',
};
